import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { Quote } from "../../../quote/quote.type";
import { QuoteLocation } from "../../../quote/models/quote-location.model";
import { Rate } from "../../../rate/rate-type";
import { LclQuote } from "../../../quote/models/quote-lcl.model";
import { quoteType } from "../../../quote/quote-form/quote-type.const";
import { locationKind } from "../../../location/location-kind.const";
import { Tooltip } from "primeng/tooltip";
import { LocationIconComponent } from "../../location-icon/location-icon.component";
import { CountryNamePipe } from "../../../shared/countries/country-name.pipe";
import { FormatContainerLabelPipe } from "../../../shared/container/format-container-label.pipe";
import { SortEquipmentPipe } from "../../../shared/container/sort-equipment.pipe";

@Component({
  selector: "app-quote-list-row",
  templateUrl: "./quote-list-row.component.html",
  styleUrls: ["./quote-list-row.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    Tooltip,
    LocationIconComponent,
    CountryNamePipe,
    FormatContainerLabelPipe,
    SortEquipmentPipe,
  ],
})
export class QuoteListRowComponent {
  @Input() public quote: Quote;

  // Manual and email quotes already put their full text in a tooltip of their own.
  public static rendersOwnTooltip(quote: Quote): boolean {
    return (
      quote.getQuoteType() === quoteType.manual ||
      quote.getQuoteType() === quoteType.email
    );
  }

  public quoteType = quoteType;
  public locationKind = locationKind;

  // How many contract names the Details cell renders before collapsing the rest into (+N).
  public visibleDetailItems = 3;

  public getQuoteTypeLabel(quote: Quote) {
    return this.isAirQuote(quote) ? "AIR" : quote.getQuoteType().toUpperCase();
  }

  public stripHtmlTags(
    html: string,
    howManyCharsToDisplay: number = html.length,
  ): string {
    const stripped = html ? html.replace(/<\/?[^>]+>|&[^;]+;/gi, "") : null;

    return howManyCharsToDisplay && stripped
      ? stripped.slice(0, howManyCharsToDisplay)
      : stripped;
  }

  public stripPlaceholders(html: string): string {
    return html ? html.replace(/\[\[.+\]\]/gi, "") : null;
  }

  public getLocationsTooltipHtml(locations: QuoteLocation[]) {
    let html = "<div>";
    locations.slice(2, locations.length).forEach((location, idx) => {
      html += `<div>`;
      html += `<strong>${
        location.getLocation() ? location.getLocation().getName() : ""
      }</strong>`;
      if (location.getInlandHaulage()) {
        html += `<br><span>inland: ${location.getInlandHaulage()}</span>`;
      }
      html += `</div>`;
      html += `${idx < locations.length - 1 ? "<hr>" : ""}`;
    });

    return html;
  }

  public getRatesTooltipHtml(rates: Rate[]) {
    let html = "<div>";
    rates.slice(this.visibleDetailItems, rates.length).forEach((rate, idx) => {
      html += `<div>`;
      html += `<strong>${rate.getName()}</strong>`;
      html += `</div>`;
      html += `${idx < rates.length - 1 ? "<hr>" : ""}`;
    });

    return html;
  }

  private isAirQuote(quote: Quote) {
    return quote instanceof LclQuote && quote.isAirQuote();
  }
}
